import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface ProductProps {
    firstProduct?: boolean
    intro?: boolean
}

interface ProductPriceProps {
    priceColor: string
    priceCSAVColor: string
}

interface ProductParagraphProps {
    even: boolean
}

interface ProductTableProps {
    conclusion?: boolean
}

export const ProductBackground = styled.div<ProductProps>`
    background: ${(props) => (props.firstProduct ? `linear-gradient(
        180deg,
        #ffffff 0%,
        #f7f7f7 50%,
        #d9d9d9 80%,
        transparent 40%
    )
    no-repeat` : 'unset')};
    margin-bottom: 40px;
`;

export const ProductContainer = styled.div`
    display: flex;
    column-gap: 20px;
    padding: 30px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #D8D8D8;

    @media screen and (max-width: 600px) {
        flex-direction: column;
        margin-bottom: 30px;
    }
`;

export const ProductImage = styled(LazyLoadImage)`
    width: 100%;
    cursor: pointer;

    @media screen and (max-width: 600px) {
        width: 100%;
        height: 
    }
`;

export const ProductContent = styled.div<ProductProps>`
    font-family: Poppins;
    text-align: left;
    display: flex;
    flex-direction: column;
    width: ${(props) => (props.intro ? '45%' : '100%')};

    @media screen and (max-width: 600px) {
        width: 100%;
    }
`;

export const ProductTable = styled.div<ProductTableProps>`
    ${(props) => (props.conclusion ? `
        max-width: 600px;
        width: 600px;
        border: 1px solid black;
        margin: 40px auto;
        margin-bottom: 10px;

        p {
            padding: 5px;
        }

        @media screen and (max-width: 650px) {
            width: 100%;
            margin: 25px auto;
            margin-bottom: 10px;
        }
    ` : `
        border-top: 2px solid black;
        margin-bottom: 10px;
    `)};
`;

export const ProductTableItem = styled.div<ProductTableProps>`
    display: flex;
    align-items: center;
    border-bottom: 1px solid gray;
    font-family: Poppins;

    :last-child {
        border-bottom: unset;
    }

    p {
        width: 50%;
        margin: 10px 0;
    }

    ${(props) => (props.conclusion ? `
        p {
            padding: 10px 5px;
            margin: 0;
            font-weight: bold;
            width: 70%;
        }

        p:last-child {
            border-left: 1px solid black;
            text-align: center;
            font-weight: normal;
            width: 30%;
        }
    ` : ``)};
`;

export const ProductTitle = styled.p`
    font-size: 31px;
    font-weight: 700;
    line-height: 35px;
    color: #4f7fa7;
    cursor: pointer;
`;

export const ProductSubtitle = styled.p`
    font-size: 22px;
    font-weight: 700;
    line-height: 35px;
    color: black;
    margin-bottom: 8px;
`;

export const ProductParagraph = styled.div<ProductParagraphProps>`
    display: flex;
    flex-direction: ${(props) => (props.even ? 'row' : 'row-reverse')};
    margin-top: 15px;

    img {
        width: 40%;
        max-height: 350px;
        border-radius: 16px;
        
        ${(props) => props.even ?  `margin-left: 20px;` : `margin-right: 20px;`}
    }

    @media screen and (max-width: 600px) {
        flex-direction: ${(props) => (props.even ? 'column' : 'column-reverse')};

        img {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
            
            ${(props) => props.even ?  `margin-top: 20px;` : `margin-bottom: 20px;`}
        }
    }
`

export const ProductScores = styled.div`
    margin-top: 16px;
`;

export const ProductScoreItem = styled.div`
    display: flex;
    align-items: center;
    margin: 5px 0;

    p {
        width: 40%;
        max-width: 400px;
        color: #626262;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        margin-right: 26px;
    }
`
export const ProductScoreTitle = styled.p`
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    color: #1F1F1F;
`

export const ProductScoreSubtitle = styled.p`
    color: #626262;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    margin: 8px 0;
`

export const ProductItems = styled.div`
    display: flex;
    align-items: center;
    margin: 24px 0;
`;

export const ProductItemImage = styled.img`
    width: 64px;
    height: 64px;
    border-radius: 64px;
    border: 2px solid #D8D8D8;
`;

export const ProductSubitems = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 16px;
`

export const ProductItem = styled.p`
    font-size: 12px;
    color: #9E9E9E;
    font-size: 12px;
    font-style: italic;
    font-weight: 400;

    span {
        font-weight: 700;
    }
`;

export const ProductDescription = styled.p`
    font-size: 16px;
    line-height: normal;
    color: #626262;
    text-align: justify;
`;

export const ProductPrices = styled.div`
    margin: 20px 0;
`

export const ProductPrice = styled.p<ProductPriceProps>`
    font-size: 16px;
    color: ${(props) => (props.priceColor)};
    font-weight: 400;
    margin-bottom: 10px;

    span {
        font-weight: 700;
        color: ${(props) => (props.priceCSAVColor)};
    }
`;

export const ProductButton = styled.button`
    width: fit-content;
    padding: 8px 20px;
    margin: 0;
`